const isBrowser = () => typeof window !== "undefined";

/**
 * Get the parent domain (e.g., ".arthalink.info") to share cookies across subdomains.
 */
export const getCookieDomain = () => {
  if (!isBrowser()) return "";
  const host = window.location.hostname;
  if (host.includes("arthalink.info")) {
    return ".arthalink.info";
  }
  return host;
};

/**
 * Set a cookie on the shared parent domain.
 */
export const setCookie = (name: string, value: string, maxAgeSeconds: number) => {
  if (!isBrowser()) return;
  const domain = getCookieDomain();
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; domain=${domain}; samesite=lax${secure}`;
};

/**
 * Get a cookie by name.
 */
export const getCookie = (name: string): string | null => {
  if (!isBrowser()) return null;
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
};

/**
 * Delete a cookie on the shared parent domain.
 */
export const deleteCookie = (name: string) => {
  if (!isBrowser()) return;
  const domain = getCookieDomain();
  document.cookie = `${name}=; path=/; max-age=0; domain=${domain}; samesite=lax`;
};
